import {
  enumUnit,
  Weight,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

const convertWeightToWeightInput = (weight: Weight | null): WeightInput => {
  if (!weight || !weight.value) {
    return {
      value: 0,
      unit: enumUnit.Pounds,
    };
  }
  return {
    value: weight.value,
    unit: weight.unit,
  };
};

export type LoadMarkAsShippedParams = {
  loadId: string;
  shippedDate?: string;
  lightWeight: Weight | null;
  heavyWeight: Weight | null;
};

export const loadMarkAsShippedAtom = createMutationAtomFactory(
  'trade.loadMarkAsShipped',
  (params: LoadMarkAsShippedParams) => ({
    tradeLoadShip: {
      __args: {
        id: params.loadId,
        shippedDate: params.shippedDate,
        lightWeight: convertWeightToWeightInput(params.lightWeight),
        heavyWeight: convertWeightToWeightInput(params.heavyWeight),
      },
      id: true,
    },
  }),
);
